import { gql } from '@apollo/client'

// Both return `image` and `updatedAt` so Apollo updates the cached league
// (Puntos header and league cards) without a refetch.
export const UPLOAD_FANTASY_LEAGUE_IMAGE = gql`
  mutation UploadFantasyLeagueImage($fantasyLeagueId: ID!, $imageBase64: String!, $contentType: String!) {
    uploadFantasyLeagueImage(
      input: { fantasyLeagueId: $fantasyLeagueId, imageBase64: $imageBase64, contentType: $contentType }
    ) {
      fantasyLeague {
        id
        image
        updatedAt
      }
      errors
    }
  }
`

export const DELETE_FANTASY_LEAGUE_IMAGE = gql`
  mutation DeleteFantasyLeagueImage($fantasyLeagueId: ID!) {
    deleteFantasyLeagueImage(input: { fantasyLeagueId: $fantasyLeagueId }) {
      fantasyLeague {
        id
        image
        updatedAt
      }
      errors
    }
  }
`
